import React from 'react';
import { Helmet } from 'react-helmet';
import { PrivacyContainer, PrivacyContent } from './estilosPrivacy'; // Importa los estilos desde el archivo styles.js en la misma carpeta que PrivacyPolicy.js


function PrivacyPolicy() {
  return (
    <PrivacyContainer>
      <Helmet>
        <title>Política de Privacidad - JuanFra Hernández</title>
        <meta name="description" content="Política de privacidad de JuanFra Hernández" />
        <link rel="canonical" href="https://juanfrahernandez.es/politica-privacidad" />
      </Helmet>
      
      <PrivacyContent>
        <h1>Política de Privacidad</h1>
        
        <p>Última actualización: {new Date().toLocaleDateString()}</p>
        
        <p>En JuanFra Hernández, accesible desde juanfrahernandez.es, una de nuestras principales prioridades es la privacidad de nuestros visitantes. Este documento de Política de Privacidad contiene tipos de información que es recopilada y registrada por JuanFra Hernández y cómo la utilizamos.</p>
        
        <p>Si tienes preguntas adicionales o requieres más información sobre nuestra Política de Privacidad, no dudes en contactarnos.</p>
        
        <h2>Información que recopilamos</h2>
        
        <p>Cuando te registras en nuestro sitio web, como parte del proceso, recopilamos la información personal que nos proporcionas, como tu nombre, dirección y dirección de correo electrónico.</p>
        
        <p>Además, recibimos y registramos automáticamente información desde tu ordenador y navegador, incluyendo tu dirección IP, software y páginas que solicitas.</p>
        
        <h2>Cómo utilizamos tu información</h2>
        
        <p>Utilizamos la información que recopilamos por varias razones:</p>
        
        <ul>
          <li>Proporcionar, operar y mantener nuestro sitio web</li>
          <li>Mejorar, personalizar y ampliar nuestro sitio web</li>
          <li>Entender y analizar cómo utilizas nuestro sitio web</li>
          <li>Desarrollar nuevos productos, servicios, características y funcionalidades</li>
          <li>Comunicarnos contigo, ya sea directamente o a través de uno de nuestros socios, para atención al cliente, para proporcionarte actualizaciones y otra información relacionada con el sitio web, y para propósitos de marketing y promocionales</li>
          <li>Enviarte correos electrónicos</li>
          <li>Encontrar y prevenir fraudes</li>
        </ul>
        
        <h2>Cookies</h2>
        
        <p>JuanFra Hernández utiliza cookies para mejorar la experiencia de los usuarios. Para más información sobre cómo utilizamos las cookies, consulta nuestra Política de Cookies.</p>
        
        <h2>Derechos RGPD</h2>
        
        <p>Si eres residente del Espacio Económico Europeo (EEE), tienes ciertos derechos de protección de datos. Nos esforzamos por tomar medidas razonables para permitirte corregir, modificar, eliminar o limitar el uso de tu información personal.</p>
        
        <p>Si deseas ser informado sobre qué información personal tenemos sobre ti y si deseas que sea eliminada de nuestros sistemas, por favor contáctanos.</p>
        
        <p>En determinadas circunstancias, tienes los siguientes derechos de protección de datos:</p>
        
        <ul>
          <li>El derecho a acceder, actualizar o eliminar la información que tenemos sobre ti</li>
          <li>El derecho de rectificación</li>
          <li>El derecho a oponerte</li>
          <li>El derecho a la restricción</li>
          <li>El derecho a la portabilidad de datos</li>
          <li>El derecho a retirar el consentimiento</li>
        </ul>
        
        <h2>Cambios a esta política de privacidad</h2>
        
        <p>Podemos actualizar nuestra Política de Privacidad de vez en cuando. Te notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página.</p>
        
        <p>Te aconsejamos que revises esta Política de Privacidad periódicamente para cualquier cambio. Los cambios a esta Política de Privacidad son efectivos cuando se publican en esta página.</p>
        
        <h2>Contacto</h2>
        
        <p>Si tienes alguna pregunta sobre esta Política de Privacidad, puedes contactarnos:</p>
        
        <ul>
          <li>Por correo electrónico: info@juanfrahernandez.es</li>
          <li>Por teléfono: +34 604 831 012</li>
          <li>Por correo postal: Calle San Benito 3, 04738 Vicar</li>
        </ul>
      </PrivacyContent>
    </PrivacyContainer>
  );
}

export default PrivacyPolicy;